














































































import type { EditDsrTabKey } from '@getaccept/dsr-shared';
import {
  TopbarWrapper,
  TopbarTitle,
  NewTopbarWrapper,
  RoomNavigation,
} from '@getaccept/dsr-shared';
import { AvatarHelper } from '@getaccept/lib-shared/src/helpers/avatars.helper';
import { TooltipPlacement } from '@getaccept/lib-shared/src/enums/tooltip-placement';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import { AvatarSize } from '@getaccept/lib-ui';
import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import NameInput from '@getaccept/dsr-shared/src/components/NameInput.vue';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { BrandingHelper } from '@getaccept/lib-shared/src/signing-theme/helpers/branding.helper';
import type { SigningTheme } from '@getaccept/lib-shared/src/signing-theme/types/theme';
import GetAcceptLogo from '@getaccept/lib-ui/src/assets/img/getaccept-logo-small.svg';

export default defineComponent({
  name: 'TopBar',
  components: {
    NewTopbarWrapper,
    TopbarWrapper,
    TopbarTitle,
    NameInput,
    RoomNavigation,
    GetAcceptLogo,
  },
  props: {
    recipients: {
      type: Array as PropType<Array<Recipient>>,
      default: () => [],
    },
    isSmallScreen: {
      type: Boolean,
    },
    currentView: {
      required: true,
      type: String as PropType<EditDsrTabKey>,
    },
    name: {
      type: String,
      default: '',
    },
    companyName: {
      type: String,
      default: '',
    },
    isDealroom: {
      type: Boolean,
    },
    theme: {
      type: Object as PropType<SigningTheme>,
      required: true,
    },
    universalLink: {
      type: String,
      default: '',
    },
    isPublicRoom: {
      type: Boolean,
    },
  },
  setup(props) {
    const logoUrl = computed(() => BrandingHelper.getLogoUrl(props.theme));

    return {
      getRecipientAvatars: AvatarHelper.getRecipientAvatars,
      TooltipPlacement,
      AvatarSize,
      logoUrl,
      t,
    };
  },
});
